import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { SidebarProvider, SidebarTrigger, useSidebar } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/AppSidebar";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import Leibrente from "./pages/Leibrente";
import Teilverkauf from "./pages/Teilverkauf";
import Rueckmiete from "./pages/Rueckmiete";
import Niessbrauch from "./pages/Niessbrauch";
import Wohnrecht from "./pages/Wohnrecht";
import Seniorenfinanzierung from "./pages/Seniorenfinanzierung";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import AGB from "./pages/AGB";

const queryClient = new QueryClient();

const App = () => {
  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <SidebarProvider>
              <AppContent />
            </SidebarProvider>
          </BrowserRouter>
        </TooltipProvider>
      </QueryClientProvider>
    </HelmetProvider>
  );
};

const AppContent = () => {
  const { isMobile, openMobile, setOpenMobile } = useSidebar();
  
  return (
    <div className="flex min-h-screen w-full bg-background">
      <AppSidebar />
      
      {/* Mobile Overlay - Only show when sidebar is open on mobile */}
      {isMobile && openMobile && (
        <div 
          className="lg:hidden fixed inset-0 bg-black/20 z-40 backdrop-blur-sm transition-opacity duration-300" 
          onClick={() => setOpenMobile(false)}
        />
      )}
      
      <div className="flex-1 flex flex-col min-w-0">
        <header className="sticky top-0 z-30 h-14 flex items-center border-b bg-background/80 backdrop-blur-sm px-4 lg:px-6">
          <SidebarTrigger className="mr-3 lg:mr-4 p-2 hover:bg-muted rounded-lg transition-colors" />
          <div className="flex-1" />
          <div className="text-sm text-muted-foreground hidden sm:block font-medium">
            EIGENHEIMVERRENTUNG
          </div>
        </header>
        <main className="flex-1 overflow-auto">
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/leibrente" element={<Leibrente />} />
            <Route path="/teilverkauf" element={<Teilverkauf />} />
            <Route path="/rueckmiete" element={<Rueckmiete />} />
            <Route path="/niessbrauch" element={<Niessbrauch />} />
            <Route path="/wohnrecht" element={<Wohnrecht />} />
            <Route path="/seniorenfinanzierung" element={<Seniorenfinanzierung />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/agb" element={<AGB />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default App;
